import React from 'react';
import PropTypes from 'prop-types';
import nutanixLogo from 'assets/nutanix-new-logo.svg';
import { FlexLayout, FlexItem, Title } from '@nutanix-ui/prism-reactjs';
import csn from 'classnames';
import naiLogo from 'assets/nai_logo.svg';
import './LoginLayout.less';
import { getCookieItem } from 'shared-utils/helpFunctions';
import getI18nService from '../../i18n/I18n';
import { TitleAppearance, TitleSizes } from '@nutanix-ui/prism-reactjs/lib/components/v2/Typography/Title';

const i18n = getI18nService();

export default class LoginLayout extends React.Component {
    static propTypes = {
        leftTitle: PropTypes.string,
        customLoginEle: PropTypes.object,
        form: PropTypes.node,
        id: PropTypes.string,
        className: PropTypes.string,
    };

    componentDidMount() {
        const spTenantName = getCookieItem('SP_TENANT_NAME');
        if (spTenantName) {
            this.setState({ isSPTenant: true, spTenantName });
        }
    }

    getContainerStyle(color_in, color_out) {
        return color_in && color_out
            ? {
                  opacity: 0.3,
                  background: `linear-gradient(45deg, ${color_in}, ${color_out})`,
              }
            : {};
    }

    render() {
        const { form, id, customLoginEle, className } = this.props;
        let { color_in, color_out, product_title, title } = customLoginEle || {};
        const containerStyle = this.getContainerStyle(color_in, color_out);

        if (this.state?.isSPTenant) {
            product_title = i18n.t('SPCentral.productTitle');
        }

        return (
            <FlexLayout className="content-wrapper" justifyContent="center" alignItems="center">
                <FlexLayout className={csn('login-layout', className)}>
                    <FlexLayout
                        className={csn('left-container', {
                            'sp-central-logo': this.state?.isSPTenant,
                        })}
                        id="left-container"
                        justifyContent="center"
                        alignItems="center"
                        flexDirection="column"
                    >
                        <FlexLayout
                            flexGrow="1"
                            className="app-logo-sidebar-container"
                            justifyContent="center"
                            alignItems="center"
                            flexDirection="row"
                            padding="10px"
                        >
                            <div
                                className="nai-logo"
                                dangerouslySetInnerHTML={{ __html: naiLogo }}
                            />
                            <FlexLayout
                                className="logo-text-container"
                                itemGap="M"
                                flexDirection="column"
                                alignItems="flex-start"
                            >
                                <Title
                                    className="logo-text"
                                    data-test-id="size-h1"
                                    size={TitleSizes.H1}
                                    appearance={TitleAppearance.NAVIGATION}
                                >
                                    {'Nutanix'}
                                </Title>
                                <Title
                                    className="logo-text"
                                    data-test-id="size-h1"
                                    size={TitleSizes.H1}
                                    appearance={TitleAppearance.NAVIGATION}
                                >
                                    {'Enterprise AI'}
                                </Title>
                            </FlexLayout>
                        </FlexLayout>
                        <FlexItem className="overlay-bg" style={containerStyle} />
                    </FlexLayout>
                    <FlexItem className="right-container" flexGrow="1" id="loginBackground">
                        <FlexLayout
                            alignItems="center"
                            flexDirection="column"
                            justifyContent="space-between"
                            id={id}
                            className="login-full-height"
                        >
                            <FlexLayout justifyContent="center">
                                {this.state?.spTenantName ? (
                                    <Title size="h1" className="tenant-name">
                                        {this.state.spTenantName}
                                    </Title>
                                ) : (
                                    <div
                                        className="nutanix-logo"
                                        dangerouslySetInnerHTML={{ __html: nutanixLogo }}
                                    />
                                )}
                            </FlexLayout>
                            <FlexLayout
                                className="login-right-inner"
                                alignItems="center"
                                justifyContent="center"
                                flexGrow="1"
                            >
                                {form}
                            </FlexLayout>
                            {this.state?.isSPTenant && (
                                <Title
                                    size={Title.TitleSizes.H4}
                                    tag="span"
                                    className="powered-by-text"
                                >
                                    {i18n.t('SPCentral.poweredBy')}
                                </Title>
                            )}
                        </FlexLayout>
                    </FlexItem>
                </FlexLayout>
            </FlexLayout>
        );
    }
}
